module.exports = __webpack_public_path__ + "static/media/foot.a22062cb.png";